// Warehouse-mobile session helpers.
// The mobile shell uses a single shared PIN + employee picker instead of the
// full admin/cashier auth flow. We stash the resulting session in
// localStorage under a *separate* key so the admin auth token stays clean
// and the ProtectedRoute guard on the desktop app still bounces these users
// off any non-/mobile URL.

const KEY = "warehouse_session_v1";

export const getWarehouseSession = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.pin_ok ? parsed : null;
  } catch {
    return null;
  }
};

export const setWarehouseSession = ({ employee, employeeId }) => {
  const s = {
    pin_ok: true,
    employee: employee || "Unknown",
    employee_id: employeeId || null,
    started_at: new Date().toISOString(),
  };
  localStorage.setItem(KEY, JSON.stringify(s));
  return s;
};

export const clearWarehouseSession = () => {
  localStorage.removeItem(KEY);
};

// Convenience for API calls that want to stamp who did the action.
export const currentWarehouseUser = () => {
  const s = getWarehouseSession();
  return s?.employee || null;
};
